
export const GET_CHOICEQUESTIONDATA = 'GET_CHOICEQUESTIONDATA' //获取精选问题数据
export const GET_HOTQUESTIONDATA = 'GET_HOTQUESTIONDATA' //获取热门问题数据
